/**
 * Formats a number with a maximum of 3 decimal places, removing trailing zeros
 * @param value - Number to format (can be null or undefined)
 * @returns Formatted string, or "-" if value is null/undefined
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "-";
  }
  
  // Round to 3 decimal places and remove trailing zeros
  const rounded = Math.round(value * 1000) / 1000;
  
  // Convert to string, removing trailing zeros
  return rounded.toString();
}



